import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import dayjs from 'dayjs';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import { SamplesFiltersProps } from './props';
import { useSamplesFilters } from './hook';
import { formatParams } from '../../../../../shared/utils/params';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import MultipleAutocompleteField from '../../../../components/general/fields/multipleAutocompleteField';

export const SamplesFilters = ({ onFilter, loading }: SamplesFiltersProps) => {
    const { formik, status, types, areas, inCharges, halfs } =
        useSamplesFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="ID caso"
                    name="caseId"
                    size="small"
                    touched={formik.touched.caseId}
                    errors={formik.errors.caseId}
                    value={formik.values.caseId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="PQR ID"
                    name="pqrId"
                    size="small"
                    touched={formik.touched.pqrId}
                    errors={formik.errors.pqrId}
                    value={formik.values.pqrId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('startCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    minDate={dayjs(formik.values.startCreatedAt)}
                    maxDate={dayjs().endOf('day')}
                    disabled={!formik.values.startCreatedAt}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('endCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Porcentaje"
                    name="percentage"
                    type="number"
                    size="small"
                    touched={formik.touched.percentage}
                    errors={formik.errors.percentage}
                    value={formik.values.percentage}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(status)}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={formatParams(types)}
                    label="Tipo PQR"
                    name="type"
                    size="small"
                    touched={formik.touched.type}
                    errors={formik.errors.type}
                    value={formik.values.type}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('type', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(areas)}
                    label="Área encargada"
                    name="area1"
                    size="small"
                    touched={formik.touched.area1}
                    errors={formik.errors.area1}
                    value={formik.values.area1 as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('area1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(inCharges)}
                    label="Encargado"
                    name="inCharge"
                    size="small"
                    touched={formik.touched.inCharge}
                    errors={formik.errors.inCharge}
                    value={formik.values.inCharge as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('inCharge', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={formatParams(halfs)}
                    label="Medio"
                    name="half"
                    size="small"
                    touched={formik.touched.half}
                    errors={formik.errors.half}
                    value={formik.values.half}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('half', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
